import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  font-family: system-ui, sans-serif;
  display: flex;
  margin-left: auto;

  span {
    color: #707070;
    font-size: 12px;
  }
`;

export const RefreshIconStyle = {
  display: 'initial',
  marginBottom: '3px',
  marginRight: '8px'
};